import { isEmpty, type TeamId } from '@terros/common'

export type TeamAddSearch = {
  parent?: string
  returnTo?: string
}

export const validateTeamAddSearch = (search: Record<string, unknown>): TeamAddSearch => ({
  parent: typeof search.parent === 'string' ? search.parent : undefined,
  returnTo: typeof search.returnTo === 'string' ? search.returnTo : undefined,
})

export const getAddTeamDestination = (teamId: TeamId, returnTo?: string): string => {
  if (isSameOriginPath(returnTo)) return returnTo
  return `/team/${teamId}`
}

const isSameOriginPath = (returnTo?: string): returnTo is string => {
  if (isEmpty(returnTo)) return false
  if (!returnTo.startsWith('/')) return false
  return !returnTo.startsWith('//') && !returnTo.startsWith('/\\')
}
